export default {
    "Now": "Now",
    "now": "now",
    "recent": "recent",
    "Forgot_password": "Forgot my password",
    "Email_address": "E-mail address",
    "Password": "Password",
    "Passwords_dont_match": "Passwords do not match",
    "Password_changed_successfully": "Password changed successfully",
    "Email_sent_recover_password": "An email was sent with instructions to recover your password",
    "Please_fill_all_fields": "Please, fill all fields",
    "An_error_occurred": "An error occurred.",
    "Wrong_old_password": "Wrong old password",
    "Reset_password": "Reset password",
    "INVALID_TOKEN": "Invalid token",
    "WRONG_PASSWORD_CONFIRMATION": "Passwords do not match",
    "Remove_vehicle_from_station": "Remove the vehicle from the station",
    "Error_in_equipment": "Error in equipment",
    "Vehicle_error": "Vehicle error",
    "Station_error": "Station error",
    "Check_if_equipment_off": "Check if the equipment is",
    "disconnected_from_power": "disconnected from power",
    "and_connect_it": "and connect it",
    "Otherwise_follow_steps": "Otherwise, if connected to power, follow these steps",
    "Not_enough_power": "Not enough power",
    "Station_max_power": "Station maximum power",
    "Contact_vehicle_supplier": "Contact your vehicle supplier",
    "Problem_persists_contact": "If the problem persists, please contact",
    "Connect_vehicle_to_station": "Connect the vehicle to the station",
    "Open_box_shutdown_circuit_wait": "Open the station box, shutdown the circuit breaker and wait 5 minutes",
    "Turn_circuit_wait": "Turn on the circuit breaker and wait 5 minutes",
    "Power_to_apply_vehicle": "Power to apply on vehicle",
    "Instructions": "Instructions",
    "No_information": "No information",
    "Total_available_power": "Total available power",
    "Plug": "Plug",
    "Next": "Next",
    "Single_phase": "Single phase",
    "Three_phase": "Three phase",
    "Previous": "Previous",
    "PRODUCER_NOT_FOUND": "User not found",
    "Insert_new_password": "Insert new password",
    "Send": "Send",
    "Login": "Login",
    "Cancel": "Cancel",
    "Schedule": "Schedule",
    "Confirm": "Confirm",
    "Confirm_schedule": "Confirm schedule",
    "charging": "charging",
    "Charging": "Charging",
    "Car_connected": "Car connected",
    "Car_not_connected": "Car not connected",
    "Charging_will_start": "Charging will start",
    "Charging_will_finish": "Charging will finish",
    "in_the_next_few_seconds": "in the next few seconds",
    "Start": "Start",
    "End": "End",
    "Finish": "Finish",
    "hello": "Hello",
    "family": "family",
    "No_Data": "No data to display",
    "Session_expired": "Session expired. Login again.",
    "Accumulated": "Accumulated",
    "last_access": "Last access",
    "hello_family": "Hello, family ",
    "production": "production",
    "consumption": "consumption",
    "production_not_used": "unused production",
    "Production": "Production",
    "Consumption": "Consumption",
    "Consumption_by_battery": "Consumption by battery",
    "Production_not_used": "Unused production",
    "Production_used": "Used production",
    "Production_used_House": "Production used by house",
    "Production_used_Battery": "Production used by battery",
    "hour": "hour",
    "Since": "Since",
    "in_use": "in use",
    "selected_date": "selected date",
    "View_data_from": "View your data from",
    "Last_hour": "Last hour",
    "Last_24_hours": "Last 24 hours",
    "Last_7_days": "Last 7 days",
    "Last_30_days": "Last 30 days",
    "more_recent": "recent",
    "historical": "historical",
    "comparison": "comparison",
    "appliances": "appliances",
    "Forecast_production": "Production (forecast)",
    "Forecast_consumption": "Consumption (forecast)",
    "Next_hours": "Next hours",
    "Station": "Station",
    "substations": "substations",
    "Substation": "Substation",
    "transformation_stations": "transformation stations",
    "Transformation_station": "Transformation station",
    "Load_diagram": "Load diagram",
    "Load": "Load",
    "State_of_charge": "State of charge",
    "System_data": "System data",
    "Current_electricty": "Current",
    "control": "control",
    "Set": "Set",
    "Active_power": "Active power",
    "Reactive_power": "Reactive power",
    "Frequency": "Frequency",
    "Apparent_power": "Apparent power",
    "Power_factor": "Power factor",
    "Voltage": "Voltage",
    "Voltage_control": "Voltage control",
    "HBF_Voltage_control": "HBF Voltage control",
    "Mode": "Mode",
    "Car": "Car",
    "Not_charging": "Not charging",
    "electric_vehicles": "electric vehicles",
    "Total_Production": "Total production",
    "Total_Consumption": "Total consumption",
    "Go_to_admin": "Go to Admin",
    "Change_password": "Change password",
    "new": "new",
    "Battery_data": "Battery data",
    "Logout": "Logout",
    "Export": "Export",
    "Loading": "Loading",
    "Battery": "Battery",
    "Welcome_back": "Welcome back",
    "Wrong_credentials": "Wrong credentials",
    "empty": "empty",
    "Savings": "Savings",
    "Actual_usage": "Actual usage",
    "of_the_energy_consumed": "of the energy consumed",
    "in_last_hour": "in the last hour",
    "in_last_24_hours": "in the last 24 hours",
    "in_last_7_days": "in the last 7 days",
    "in_last_30_days": "in the last 30 days",
    "was_produced_by_system": "was produced by your system",
    "Energy_consumed_from_grid":"Energy consumed from grid",
    "Energy_consumed_from_grid_to_house":"Energy consumed from grid by house",
    "Energy_consumed_from_grid_to_battery":"Energy consumed from grid by battery",
    "Energy_consumed_from_production":"Energy consumed from production",
    "Energy_consumed_by_house_from_production":"Energy consumed from production by house",
    "Energy_consumed_by_battery_from_production":"Energy consumed from production by battery",
    "Energy_consumed_from_battery_to_house": "Energy consumed from battery by house",
    "Energy_produced_consumed_by_battery": "Produced energy consumed by battery",
    "Electric_grid": "Electric grid",
    "Electric_grid_to_house": "Electric grid to house",
    "Electric_grid_to_battery": "Electric grid to battery",
    "Production_to_house": "Production to house",
    "Production_to_battery": "Production to battery",
    "Battery_to_house": "Battery to house",
    "Wasted_energy": "Wasted energy",
    "Battery_occupation": "Battery occupation",
    "Consumption_details": "Consumption details",
    "Recent_usage": "Recent energy usage",
    "Total_energy_consumed": "Total energy consumed",
    "Total_energy_produced": "Total energy produced",
    "Day_of_week": "Day of week",
    "Production_Consumption_Weekdays_Weekends": "Production and Consumption - Week days/Weekends",
    "Appliances_breakdown": "Appliances breakdown",
    "Appliance": "Appliance",
    "appliance": "appliance",
    "Close": "Close",
    "All": "All",
    "Charge": "Charge",
    "Charging_mode": "Charging mode",
    "Charging_in_mode": "Charging in mode",
    "Charging_will_be_done_automatically": "Charging will be done with automatically calculated values.",
    "Select_power_of_charge": "Select the power of charge",
    "Automatic": "Automatic",
    "Manual": "Manual",
    "Partly_cloudy": "Partly cloudy",
    "Cloudy": "Cloudy",
    "Rainy": "Rain",
    "Clear": "Clear",
    "Snowy": "Snow",
    "Hail": "Hail",
    "Wind": "Wind",
    "Heavy_rain": "Heavy rain",
    "Showers": "Showers",
    "Fog": "Fog",
    "Thunderstorm": "Thunderstorm",
    "Share": "Share",
    "Period_of_time": "Period of time",
    "Select_control_mode": "Select control mode",
    "Start_date": "Start date",
    "End_date": "End date",
    "Click_button_below_to_add_setpoints": "Click the button below to add more setpoints",
    "Idle": "Idle",
    "From": "From",
    "Current": "Current",
    "Current_mode": "Current mode",
    "Set_control_mode": "Set control mode",
    "No_setpoints": "No setpoints",
    "To": "To",
    "Select_period_of_time": "Select the period of time",
    "Select_appliance": "Select the appliance",
    "Select_date": "Select the date",
    "Cheapest_hours": "Empty hours",
    "Battery_wont_be_used": "Battery that will not be used",
    "Battery_limits": "Battery limits",
    "Date": "Date",
    "Dates": "Dates",
    "View": "View",
    "Day": "Day",
    "Week": "Week",
    "Month": "Month",
    "Energy_usage": "Energy usage",
    "Production_and_Consumption": "Production and Consumption",
    "this_day": "in this day",
    "this_month": "in this month",
    "this_week": "in this week",
    "Current_password": "Current password",
    "New_password":"New password",
    "Consumption_of_produced_energy": "Consumption of produced energy",
    "Device": "Device",
    "Not_available": "Not available",
    "Normal": "Normal",
    "Smart": "Smart",
    "Type_of_charge": "Type of charge",
    "Battery_charge": "Battery charge",
    "Battery_discharge": "Battery discharge",
    "at": "at",
    "of_the_appliances_total_consumption_was_from": "of the appliances total consumption was from",
    "comparison_tooltip_consumption":"This section shows the consumption data for the two selected dates, in Watts (W).",
    "comparison_tooltip_prod_cons": "This section shows the total consumption and production data for the two selected dates, in kWh.",
    "comparison_tooltip_energy_use": "This section details the source of consumption and wastage, for the two selected dates, in kWh.",
    "comparison_tooltip_cons_produced": "This section shows how much of the energy your system consumed was produced on the two dates you selected.",
    "historical_tooltip_energy_usage": "This section shows consumption, production, and unused (waste) data for the selected date in Watts (W).",
    "historical_tooltip_savings": "This section indicates the energy saving (kWh), monetary (€) and environmental (gCO2) savings values for the selected date.",
    "historical_tooltip_wastings": "This section indicates how much of the energy produced was not used (wasted) on the selected date, in kWh.",
    "historical_tooltip_cons_details": "This section indicates the source of the energy consumed and the quantity, in the selected date, in kWh.",
    "historical_tooltip_prod_cons_weeks": "This section shows consumption, production and unused production data for each selected weekday, in kWh.",
    "historical_tooltip_prod_cons_months": "This section shows unused consumption, production, and production data for each week and weekend of the selected month, in kWh.",
    "home_tooltip_actual_usage": "This section indicates the current values of energy consumed, produced and wasted, in Watts (W).", 
    "home_tooltip_select_period": "In this section you can select the length of time you want to see so far.", 
    "home_tooltip_recent_usage": "This section shows consumption, production, and waste data over the selected period, in Watts (W).", 
    "home_tooltip_savings": "This section indicates the energy saving (kWh), monetary (€) and environmental (gCO2) savings values for the selected period.", 
    "home_tooltip_wastings": "This section indicates how much of the energy produced was not used (wasted), for the selected period, in kWh.",
    "home_tooltip_cons_details": "This section indicates the source of the energy consumed and the quantity, for the selected period, in kWh.", 
    "home_tooltip_weekdays": "This section indicates the total values of energy consumed, produced and produced not used for each day of the week, in kWh.",
    "home_tooltip_months": "This section indicates the total values of energy consumed, produced and produced not used for weekdays and weekends, in kWh.",
    "home_tooltip_battery_occupation": "This section shows the percentage of the batteries occupation alongside with the empty hour period and the upper and lower bounds of the battery, on the selected date.",
    "appliances_tooltip_breakdown": "This section shows the consumption values of each appliance and the total consumption, for the selected date, in kWh.",
    "appliances_tooltip_appliance": "This section displays the consumption data of the selected appliance and the unused production (waste), on the selected date, in kWh.",
    "ev_tooltip_consumption": "This section shows the consumption data from the electric vehicles for the selected date, in Watts (W)."
}